import { type LogMessage } from "@src/components/Type";
import { type IntlShape } from "react-intl";

export const generateType = (message: LogMessage | string, intl: IntlShape): string => {
    if (message === "SendSMS") {
        return intl.formatMessage({ id: "reviermanager.camera.activity.type.sendSMS", defaultMessage: "SMS ausgehend" });
    } else if (message === "ReceivedSMS") {
        return intl.formatMessage({ id: "reviermanager.camera.activity.type.receivedSMS", defaultMessage: "SMS antwort" });
    } else if (message === "CommandInvalid") {
        return intl.formatMessage({ id: "reviermanager.camera.activity.type.commandInvalid", defaultMessage: "SMS ungültig" });
    } else if (message === "FailedSMS") {
        return intl.formatMessage({ id: "reviermanager.camera.activity.type.failedSMS", defaultMessage: "SMS fehlgeschlagen" });
    } else if (message === "SendFailure") {
        return intl.formatMessage({ id: "reviermanager.camera.activity.type.sendFailure", defaultMessage: "Bildübertragung fehlgeschlagen" });
    } else if (message === "StartedMoveSim") {
        return intl.formatMessage({
            id: "reviermanager.camera.activity.type.startedMoveSim",
            defaultMessage: "Sim verschieben wurde gestartet",
        });
    } else if (message === "FinishedMoveSim") {
        return intl.formatMessage({
            id: "reviermanager.camera.activity.type.finishedMoveSim",
            defaultMessage: "Sim wurde erfolgreich verschoben",
        });
    } else if (message === "VideoRequested") {
        return intl.formatMessage({ id: "reviermanager.camera.activity.type.videoRequested", defaultMessage: "Video angefordert" });
    } else if (message === "VideoRequestFailed") {
        return intl.formatMessage({
            id: "reviermanager.camera.activity.type.videoRequestFailed",
            defaultMessage: "Video-Anforderung fehlgeschlagen",
        });
    } else if (message === "VideoReceived") {
        return intl.formatMessage({ id: "reviermanager.camera.activity.type.videoReceived", defaultMessage: "Video empfangen" });
    } else {
        return message;
    }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const generateContentString = (values: any, result: any[] = []): string => {
    if (!values) {
        return "";
    }

    Object.entries(values).forEach(([key, value]) => {
        if (key === "command") {
            return;
        }

        if (typeof value !== "object") {
            result.push(value);
        } else {
            generateContentString(value, result);
        }
    });

    return result.join(",");
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getContent = (values: any, separator = ""): string => {
    if (values) {
        const { prefix: prefixValue, code, ...rest } = values;
        const prefix = prefixValue ? `#${prefixValue}${separator}` : "";

        return `${prefix}${code ?? ""}${generateContentString(rest)}`;
    }

    return "";
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generateContent = (intl: IntlShape, { send, receive, message }: { send: any; receive: any; message: string }): string => {
    return getContent(send) + getContent(receive, "# ");
};
